import Marquee from "react-fast-marquee";

export default function EditorialMarquee() {
  const words = ["FOOTBALL COACHING", "FITNESS COACHING", "HIGH PERFORMANCE", "1-ON-1 TRAINING"];
  return (
    <section data-testid="marquee" className="py-10 md:py-16 border-y border-white/10 bg-black/30 backdrop-blur-sm">
      <Marquee speed={45} gradient={false} autoFill>
        {words.map((w, i) => (
          <div key={i} className="flex items-center">
            <span className="text-stroke font-display font-bold uppercase text-[9vw] md:text-[7vw] leading-none px-8">
              {w}
            </span>
            <span className="text-[#2E6BE6] text-[6vw] md:text-[4vw]">✦</span>
          </div>
        ))}
      </Marquee>
    </section>
  );
}
